import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectOption } from '@app/interfaces/sys/dict';
import { Feature } from '@app/interfaces/sys/permission';
import { AddRole, EditPermission, Role, RoleParams, RoleWithPage } from '@app/interfaces/sys/role';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RoleService {
    private moduleApi = environment.api.services.sys;

    private baseUrl = this.moduleApi + '/roles';
    private lmRoles: SelectOption[] = [
        {
            value: 'LM_ROLE_ENGINEER',
            label: 'Engineer'
        },
        {
            value: 'LM_ROLE_LAB_ADMIN',
            label: 'Lab Admin'
        },
        {
            value: 'LM_ROLE_MANAGER',
            label: 'Manager'
        },
        {
            value: 'LM_ROLE_TESTER',
            label: 'Tester'
        },
        {
            value: 'LM_ROLE_SUPER_ADMIN',
            label: 'Super Admin'
        }
    ];

    constructor(private http: HttpClient) {
    }

    async find(params?: RoleParams): Promise<RoleWithPage> {
        return lastValueFrom(this.http.get<RoleWithPage>(this.baseUrl, {
            params: params ? Object.assign(params) : null,
        }));
    }

    async findOptions(): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`));
    }

    async detail(id: number): Promise<Role> {
        return lastValueFrom(this.http.get<Role>(`${this.baseUrl}/one`, {
                params: Object.assign({ id }),
        }));
    }

    async add(data: AddRole): Promise<void> {
        return lastValueFrom(this.http.post<void>(this.baseUrl, data));
    }

    async edit(data: Role): Promise<void> {
        return lastValueFrom(this.http.put<void>(this.baseUrl, data));
    }

    async editPermission(data: EditPermission): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}/features`, data));
    }

    async syncFeature(data: { features: Feature[] }): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.moduleApi}/feature-apis`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    async findRole(): Promise<SelectOption[]> {
        return new Promise(resolve => {
            resolve(this.lmRoles);
        });
    }

    roleFormat(arr: string[], roleArr?: SelectOption[]): string {
        if (!arr || arr.length < 0) {
            return '';
        }
        const roleOptions = roleArr && roleArr.length > 0 ? roleArr : this.lmRoles;
        const res = arr.map((item) => {
            const role = roleOptions.find((roleItem) => roleItem.value === item);
            return role ? role.label : item;
        });
        return res.join(',');
    }


    isAdmin(roleNames: string[]): boolean {
        const arr = roleNames?.map(item => item?.toLowerCase());
        return arr?.includes('admin');
    }
}
